export const UPDATE_COUPON_LIST_REQUEST = "UPDATE_COUPON_LIST_REQUEST"
export const GET_COUPON_LIST = "GET_COUPON_LIST"
export const GET_COUPON_LIST_LOADING = "GET_COUPON_LIST_LOADING"
export const INITIAL_STATE = "INITIAL_STATE"
export const DASHBOARD_OVER_VIEW = "DASHBOARD_OVER_VIEW"